export default __webpack_public_path__ + "static/media/DoingWellWithoutEdit.0389f952.png";